import React, { useCallback, useState } from 'react';
import { xcss, Box, Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { FieldPin } from '@atlassian/jira-issue-field-pin/src/index.tsx';
import { DEV_SUMMARY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { NestedPanel } from '@atlassian/jira-issue-nested-panel/src/ui/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

export const DevelopmentFieldWrapper = ({
	children,
	afterHeadingNode,
	pinnable = false,
	labelTitle,
	contentId = 'dev-info-panel',
	showBottomSeparator = false,
	prefetch = false,
	title = <></>,
	pinnableFieldId = DEV_SUMMARY_TYPE,
	hideTitleOnExpand = false,
	isOpen = false,
}: Props) => {
	const [isNestedPanelOpen, setIsNestedPanelOpen] = useState(isOpen);

	const onToggleNestedPanel = useCallback(() => {
		setIsNestedPanelOpen(!isNestedPanelOpen);
	}, [isNestedPanelOpen]);

	const { formatMessage } = useIntl();
	const titleLabel = labelTitle;
	return (
		<NestedPanel
			ariaLabelExpand={formatMessage(messages.ariaLabelExpand)}
			ariaLabelCollapse={formatMessage(messages.ariaLabelCollapse)}
			contentId={contentId}
			isOpen={isNestedPanelOpen}
			label={
				<Flex gap="space.100" xcss={NestedPanelHeadingTitle}>
					{titleLabel}
					{afterHeadingNode}
					{pinnable && <FieldPin fieldId={pinnableFieldId} label={titleLabel} />}
				</Flex>
			}
			onToggle={onToggleNestedPanel}
			showBottomSeparator={showBottomSeparator}
			hideTitleOnExpand={hideTitleOnExpand}
			title={title}
			prefetch={prefetch}
		>
			<Box xcss={NestedPanelChildrenStyles}>{children}</Box>
		</NestedPanel>
	);
};

export default DevelopmentFieldWrapper;

const NestedPanelHeadingTitle = xcss({
	flexGrow: 1,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	minWidth: '0px',
});

const NestedPanelChildrenStyles = xcss({
	// I don't love this, but it's the only way to get the  icons of the children to be lined up with the field title.
	// i _could_ add a negative margin and calc width to the children, but this introduces less complexity overall (IMO).
	// I could also remove padding left from the children, but this just makes the button styles inconsistent
	width: `calc(100% + ${token('space.050')})`,
	marginLeft: 'space.negative.050',
});
